/* Header: search overlay with suggestions, menu/account drawers; closes them when the cart drawer opens. */
(() => {
  if (customElements.get('nt-header')) return;
  class NtHeader extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const open = e.target.closest('[data-nt-open]');
        if (open) { e.preventDefault(); this.toggle(open.dataset.ntOpen, open); return; }
        if (e.target.closest('[data-nt-close]')) { e.preventDefault(); this.closeAll(); return; }
        /* Cart icon: Dawn's cart drawer / notification opens itself from #cart-icon-bubble; only close our own panels first. */
        if (e.target.closest('[data-nt-cart]')) { this.closeAll(true); this.measure(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.current) this.closeAll(); });
      this.measure();
      addEventListener('resize', () => this.measure(), { passive: true });
      addEventListener('scroll', () => { if (!this.ticking) { this.ticking = true; requestAnimationFrame(() => { this.ticking = false; this.measure(); }); } }, { passive: true });
      const input = this.querySelector('[data-nt-suggest]');
      if (input) {
        let t;
        input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.suggest(input.value.trim()), 180); });
      }
    }
    /* Where the header ends on screen: panels start their content below it. */
    measure() {
      const bar = this.querySelector('.nt-hd__bar');
      if (bar) document.documentElement.style.setProperty('--nt-hd-bottom', `${Math.max(0, Math.round(bar.getBoundingClientRect().bottom))}px`);
      /* Full header height at the top of the page (announcement + header), used by the hero's 'share of screen' height. */
      let h = 0; document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => { h += el.offsetHeight; });
      if (h && h !== this.headerH) { this.headerH = h; document.documentElement.style.setProperty('--nt-header-h', `${h}px`); }
    }
    closeCart() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
    }
    panel(name) { return this.querySelector({ search: '#NtSearch', menu: '#NtMenu', account: '#NtAccount' }[name]); }
    toggle(name, trigger) {
      if (this.current === name) { this.closeAll(); return; }
      this.closeAll(true);
      this.closeCart();
      this.measure();
      const el = this.panel(name); if (!el) return;
      this.current = name; this.trigger = trigger;
      el.hidden = false;
      requestAnimationFrame(() => el.classList.add('is-open'));
      trigger.setAttribute('aria-expanded', 'true');
      if (name !== 'search') document.body.classList.add('nt-lock');
      const focus = el.querySelector('input, a, button:not([data-nt-close])') || el.querySelector('button');
      setTimeout(() => focus && focus.focus(), 60);
    }
    closeAll(silent) {
      if (!this.current) return;
      const el = this.panel(this.current);
      el.classList.remove('is-open');
      const delay = this.current === 'search' ? 0 : 450;
      setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, delay);
      document.body.classList.remove('nt-lock');
      if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'false'); if (!silent) this.trigger.focus(); }
      this.current = null;
    }
    async suggest(q) {
      const box = this.querySelector('[data-nt-results]');
      if (!q || q.length < 2) { box.innerHTML = ''; return; }
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`;
        const data = await (await fetch(url)).json();
        const items = data.resources?.results?.products || [];
        const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        box.innerHTML = items.map((p) => `<a class="nt-hd__res" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}&width=88" alt="" width="44" height="44" loading="lazy">` : ''}<span>${esc(p.title)}</span><span>${esc(p.price ? '£' + p.price : '')}</span></a>`).join('')
          + `<a class="nt-hd__res nt-hd__res--all" href="/search?q=${encodeURIComponent(q)}">See all results for “${esc(q)}”</a>`;
      } catch (e) { box.innerHTML = ''; }
    }
  }
  customElements.define('nt-header', NtHeader);
})();
